import { IOfferAllLang } from '../../../types/lang'
import { offerListTableLang } from './offerListTable'
import { offerListModalLang } from './offerListModal'


export const offerAllLang: IOfferAllLang = {
	...offerListTableLang,
	...offerListModalLang
}